module.exports = __webpack_public_path__ + "static/ko-f2ae4d44285ce1888461caa728b0063d.png";